import { useEffect, useState } from "react";
import { t } from "i18next";
import { Tag, Tooltip, Button, Modal } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import DataGrid from "../../core/components/data-grid/DataGrid";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";
import Helper from "../../core/Helper";
import ApiService from "../../core/service/ApiService";

export default function MailLogDataGrid() {
    const { queryModel, setDataGridProps, setData, setPaginationResult } = useDataGrid();
    const [detail, setDetail] = useState(null);

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                {
                    dataIndex: 'createdDate', key: 'createdDate', title: t('Date'), sorter: true, width: 160,
                    render: (val) => Helper.Date.dateFormat(val)
                },
                { dataIndex: 'toEmail', key: 'toEmail', title: t('Email'), width: 200, render: (val) => val || '-' },
                {
                    dataIndex: 'recipientName', key: 'recipientName', title: t('Recipient'), width: 180,
                    render: (val) => val || '-'
                },
                { dataIndex: 'senderName', key: 'senderName', title: t('Sender'), width: 140, render: (val) => val || '-' },
                { dataIndex: 'subject', key: 'subject', title: t('Subject'), render: (val) => val || '-' },
                {
                    dataIndex: 'success', key: 'success', title: t('Status'), sorter: true, width: 100,
                    render: (val, row) => val
                        ? <Tag color="success">{t('Sent')}</Tag>
                        : <Tooltip title={row.error}><Tag color="error">{t('Failed')}</Tag></Tooltip>
                },
                {
                    key: 'detail', title: '', width: 110, align: 'center',
                    render: (_, row) => <Button size="small" icon={<EyeOutlined />} onClick={() => setDetail(row)}>{t('View')}</Button>
                },
            ]
        })
    }, [])

    const load = async () => {
        const res = await ApiService.SmsLog.GetMailLogDataGrid(queryModel);
        if (res.success) {
            setData(res.data)
            setPaginationResult(res.pagination);
        }
    }

    useEffect(() => { load() }, [queryModel.updateKey])

    return (
        <>
            <DataGrid />
            <Modal
                open={!!detail}
                title={t('Email')}
                onCancel={() => setDetail(null)}
                footer={<Button onClick={() => setDetail(null)}>{t('Close')}</Button>}
                width={720}
            >
                {detail?.error && (
                    <>
                        <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('Error')}</div>
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#cf1322', background: '#fff1f0', padding: 8, borderRadius: 4, marginBottom: 12 }}>
                            {detail.error}
                        </pre>
                    </>
                )}
                <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('Message content')}</div>
                <div
                    style={{ background: '#f5f5f5', padding: 8, borderRadius: 4, maxHeight: 360, overflow: 'auto' }}
                    dangerouslySetInnerHTML={{ __html: detail?.body || '-' }}
                />
            </Modal>
        </>
    )
}
